export default {
  APPLY_SEARCH_FILTERS: 'APPLY_SEARCH_FILTERS',
  APPLY_CICS_FILTERS: 'APPLY_CICS_FILTERS',
  CLEAR_FILES: 'CLEAR_FILES',
  CLEAR_ANALYTICS: 'CLEAR_ANALYTICS',
  CLEAR_FRAGRANCES: 'CLEAR_FRAGRANCES',
  CLEAR_CONCEPTS: 'CLEAR_CONCEPTS',
  CLEAR_QUESTIONS: 'CLEAR_QUESTIONS',
  CLEAR_STUDY_SUMMARIES: 'CLEAR_STUDY_SUMMARIES',
  CHECK_METRIC_JOB_STATUS: 'CHECK_METRIC_JOB_STATUS',
  CHECK_STUDY_FILE_UPLOAD_STATUS: 'CHECK_STUDY_FILE_UPLOAD_STATUS',
  CHECK_METRIC_JOB_STATUS_AND_GET_DATA: 'CHECK_METRIC_JOB_STATUS_AND_GET_DATA',
  CHECK_PERFORMANCE_JOB_STATUS: 'CHECK_PERFORMANCE_JOB_STATUS',
  CHECK_ATTRIBUTES_JOB_STATUS: 'CHECK_ATTRIBUTES_JOB_STATUS',
  CHECK_TENDENCIES_JOB_STATUS: 'CHECK_TENDENCIES_JOB_STATUS',
  CHECK_METRIC_XLSX_JOB_STATUS: 'CHECK_METRIC_XLSX_JOB_STATUS',
  CHECK_PERFORMANCE_XLSX_JOB_STATUS: 'CHECK_PERFORMANCE_XLSX_JOB_STATUS',
  CHECK_ATTRIBUTES_XLSX_JOB_STATUS: 'CHECK_ATTRIBUTES_XLSX_JOB_STATUS',
  DELETE_SAVED_SEARCH: 'DELETE_SAVED_SEARCH',
  EDIT_STUDIES: 'EDIT_STUDIES',
  FETCH_TENDENCIES: 'FETCH_TENDENCIES',
  FETCH_ANALYTICS: 'FETCH_ANALYTICS',
  FETCH_ANALYTICS_FIELDS: 'FETCH_ANALYTICS_FIELDS',
  FETCH_CICS_FIELDS: 'FETCH_CICS_FIELDS',
  FETCH_CICS_QUESTIONS: 'FETCH_CICS_QUESTIONS',
  FETCH_CICS_QUESTION_DATA: 'FETCH_CICS_QUESTION_DATA',
  FETCH_FIELDS: 'FETCH_FIELDS',
  FETCH_FILE: 'FETCH_FILE',
  FETCH_FILES: 'FETCH_FILES',
  FETCH_FRAGRANCE_PROFILE: 'FETCH_FRAGRANCE_PROFILE',
  FETCH_CONCEPT_PROFILE: 'FETCH_CONCEPT_PROFILE',
  FETCH_SUMMARIES_XLSX: 'FETCH_SUMMARIES_XLSX',
  FETCH_FRAGRANCE_XLSX: 'FETCH_FRAGRANCE_XLSX',
  FETCH_FRAGRANCE_XLSX_FILTERS: 'FETCH_FRAGRANCE_XLSX_FILTERS',
  FETCH_METRICS: 'FETCH_METRICS',
  FETCH_XLSX_FILE: 'FETCH_XLSX_FILE',
  FETCH_QUESTIONS: 'FETCH_QUESTIONS',
  GET_FRAGRANCE_PROFILE_XLSX: 'GET_FRAGRANCE_PROFILE_XLSX',
  FETCH_STUDY_FILES: 'FETCH_STUDY_FILES',
  FETCH_STUDIES_COUNT: 'FETCH_STUDIES_COUNT',
  FETCH_FRAGRANCES: 'FETCH_FRAGRANCES',
  FETCH_CONCEPTS: 'FETCH_CONCEPTS',
  FETCH_RELATED_STUDY_FILES: 'FETCH_RELATED_STUDY_FILES',
  FETCH_SAVED_SEARCHES: 'FETCH_SAVED_SEARCHES',
  FETCH_TENDENCIES_XLSX: 'FETCH_TENDENCIES_XLSX',
  FETCH_STUDIES: 'FETCH_STUDIES',
  FETCH_STUDY_SUMMARIES: 'FETCH_STUDY_SUMMARIES',
  FETCH_STUDY_DETAILS: 'FETCH_STUDY_DETAILS',
  FETCH_STUDY_TAGS: 'FETCH_STUDY_TAGS',
  POST_SAVED_SEARCH: 'POST_SAVED_SEARCH',
  POST_TAG_EDIT: 'POST_TAG_EDIT',
  QUEUE_METRIC_SEARCH: 'QUEUE_METRIC_SEARCH',
  QUEUE_METRIC_SEARCH_AND_GET_JOB_ID: 'QUEUE_METRIC_SEARCH_AND_GET_JOB_ID',
  QUEUE_NEW_ANALYTIC_SEARCH: 'QUEUE_NEW_ANALYTIC_SEARCH',
  QUEUE_PERFORMANCE_SEARCH: 'QUEUE_PERFORMANCE_SEARCH',
  QUEUE_ATTRIBUTES_SEARCH: 'QUEUE_ATTRIBUTES_SEARCH',
  QUEUE_TENDENCIES_SEARCH: 'QUEUE_TENDENCIES_SEARCH',
  QUEUE_METRIC_XLSX_DOWNLOAD: 'QUEUE_METRIC_XLSX_DOWNLOAD',
  QUEUE_PERFORMANCE_XLSX_DOWNLOAD: 'QUEUE_PERFORMANCE_XLSX_DOWNLOAD',
  QUEUE_ATTRIBUTES_XLSX_DOWNLOAD: 'QUEUE_ATTRIBUTES_XLSX_DOWNLOAD',
  RESET_SEARCH_FILTERS: 'RESET_SEARCH_FILTERS',
  RESET_CICS_FILTERS: 'RESET_CICS_FILTERS',
  UPDATE_CICS_FILTERS: 'UPDATE_CICS_FILTERS',
  UPDATE_DROPDOWN_OPTIONS: 'UPDATE_DROPDOWN_OPTIONS',
  UPDATE_METRICS_DROPDOWN_OPTIONS: 'UPDATE_METRICS_DROPDOWN_OPTIONS',
  SET_OR_CLEAR_SEARCH_FILTERS: 'SET_OR_CLEAR_SEARCH_FILTERS',
  SET_FRAGRANCES: 'SET_FRAGRANCES',
  SET_CONCEPTS: 'SET_CONCEPTS',
  UPDATE_STUDY_MAPPING: 'UPDATE_STUDY_MAPPING',
  UPDATE_STUDY_DETAILS: 'UPDATE_STUDY_DETAILS',
  QUEUE_SIGNIFICANCE_CALCULATION: 'QUEUE_SIGNIFICANCE_CALCULATION',
  CHECK_SIGNIFICANCE_JOB_STATUS: 'CHECK_SIGNIFICANCE_JOB_STATUS',
  UPLOAD_STUDIES: 'UPLOAD_STUDIES',
  CHECK_STUDIES_TASK_STATUS: 'CHECK_STUDIES_TASK_STATUS',
  FETCH_PROCESS_FILE_DETAILS: 'FETCH_PROCESS_FILE_DETAILS',
  UPDATE_FILE_PROCESS: 'UPDATE_FILE_PROCESS',
  DOWNLOAD_FILE_FROM_FILE_PROCESS: 'DOWNLOAD_FILE_FROM_FILE_PROCESS',
  PROCESS_STUDIES: 'PROCESS_STUDIES',
  FETCH_FILE_PROCESS: 'FETCH_FILE_PROCESS',
  SEND_RDF_DATA: 'SEND_RDF_DATA',
  GET_RDF: 'GET_RDF',
  GET_STUDY_METRICS: 'GET_STUDY_METRICS',
  UPLOAD_RDF_DATA: 'UPLOAD_RDF_DATA',
  CHECK_ALL_CLOSE_ENDED_QUESTIONS: 'CHECK_ALL_CLOSE_ENDED_QUESTIONS',
  FETCH_STUDY_EDIT_HISTORY: 'FETCH_STUDY_EDIT_HISTORY'
}
